"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_includes_1 = __importDefault(require("lodash.includes"));
/**
 * Module Dependencies.
 */
var debug = require('debug')('analytics.js:normalize');
var type = require('component-type');
var uuid = require('uuid/v4');
var md5 = require('spark-md5').hash;
/**
 * HOP.
 */
var has = Object.prototype.hasOwnProperty;
/**
 * Expose `normalize`
 */
module.exports = normalize;
/**
 * Toplevel properties.
 */
var toplevel = ['integrations', 'anonymousId', 'timestamp', 'context'];
function normalize(msg, list) {
    var lower = list === null || list === void 0 ? void 0 : list.map(function (s) {
        return s.toLowerCase();
    });
    var opts = msg.options || {};
    var integrations = opts.integrations || {};
    var providers = opts.providers || {};
    var context = opts.context || {};
    var ret = {};
    debug('<-', msg);
    // integrations.
    Object.keys(opts).forEach(function (key) {
        if (!integration(key))
            return;
        if (!has.call(integrations, key))
            integrations[key] = opts[key];
        delete opts[key];
    });
    // providers.
    delete opts.providers;
    Object.keys(providers).forEach(function (key) {
        if (!integration(key))
            return;
        if (type(integrations[key]) === 'object')
            return;
        if (has.call(integrations, key) && typeof providers[key] === 'boolean')
            return;
        integrations[key] = providers[key];
    });
    // move all toplevel options to msg
    // and the rest to context.
    Object.keys(opts).forEach(function (key) {
        if (lodash_includes_1.default(toplevel, key)) {
            ret[key] = opts[key];
        }
        else {
            context[key] = opts[key];
        }
    }, opts);
    // generate and attach a messageId to msg
    msg.messageId = 'ajs-' + md5(window.JSON.stringify(msg) + uuid());
    // cleanup
    delete msg.options;
    ret.integrations = integrations;
    ret.context = context;
    ret = __assign(__assign({}, msg), ret);
    debug('->', ret);
    return ret;
    function integration(name) {
        return !!(lodash_includes_1.default(list, name) ||
            name.toLowerCase() === 'all' ||
            lodash_includes_1.default(lower, name.toLowerCase()));
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@segment/analytics.js-core/build/normalize.js
// module id = 832
// module chunks = 0